const MainUrl = 'https://urbanshineapi.crieatazoomkar.com/';

export default MainUrl;